/**
 * @license
 * Copyright Endlessjs. All Rights Reserved.
 * Licensed under the MIT License. See License.txt in the project root for license information.
 */

import { NgModule } from '@angular/core';

import { ElSharedModule } from '../shared/shared.module';

import { ElRouteTabsetComponent } from './route-tabset.component';
import { ElIconModule } from '../icon/icon.module';

@NgModule({
  imports: [
    ElSharedModule,
    ElIconModule,
  ],
  declarations: [
    ElRouteTabsetComponent,
  ],
  exports: [
    ElRouteTabsetComponent,
  ],
})
export class ElRouteTabsetModule { }
